import { type Store, storeToRefs } from 'pinia';

/**
 * Returns a store whose state is already unwrapped into refs, so consumers can
 * destructure both state and actions in one go:
 *
 * `const { notifications, addNotification } = useNotifications();`
 */
export const usePiniaRefStore = <T extends Store>(store: T) => {
  const refs = storeToRefs(store);

  return { ...store, ...refs };
};
